module.exports = __webpack_public_path__ + "img/news-feed-icon.c07328c9.svg";